import React from 'react';
import GlobalScoreContent from '../GlobalScoreContent';
import SeoScoreContent from '../SeoScoreContent';
import UxScoreContent from '../UxScoreContent';

const DynamicScoreContent = ({
  activeTab,
  scoreData,
  isEditing,
  websites, // List of internal links provided
  actualHtmlContent,
  setIsEditing,
  handleInputChange,
  checkIfAllLinesGreen, // Function to verify if all links are properly formatted
  userRole,
  onGapUpdate,
  isKeywordBoxReadOnly,
  combinedKeywords,
  handleKeywordChange,
  orderContentType,
  autoKeywordsGenerationLoading,
  isReadOnly,
  wordCount,
  keyword,
  url,
  orderWebsite,
  language,
  country,
  gapAnalysisEnabled,
  onGapEditingChange,
}) => {
  switch (activeTab) {
    case 'global':
      return <GlobalScoreContent scoreData={scoreData} />;
    case 'seo':
      return (
        <SeoScoreContent
          scoreData={scoreData}
          isEditing={isEditing}
          websites={websites}
          actualHtmlContent={actualHtmlContent}
          setIsEditing={setIsEditing}
          handleInputChange={handleInputChange}
          checkIfAllLinesGreen={checkIfAllLinesGreen}
          userRole={userRole}
          onUpdate={onGapUpdate}
          isKeywordBoxReadOnly={isKeywordBoxReadOnly}
          combinedKeywords={combinedKeywords}
          handleKeywordChange={handleKeywordChange}
          orderContentType={orderContentType}
          autoKeywordsGenerationLoading={autoKeywordsGenerationLoading}
          keyword={keyword}
          url={url}
          orderWebsite={orderWebsite}
          language={language}
          country={country}
          gapAnalysisEnabled={gapAnalysisEnabled}
          onGapEditingChange={onGapEditingChange}
        />
      );
    case 'ux':
      return <UxScoreContent scoreData={scoreData} wordCount={wordCount} />;
    default:
      return null;
  }
};

export default DynamicScoreContent;
